import { render, staticRenderFns } from "./StorefinderContactDialog.vue?vue&type=template&id=6a16036e"
import script from "./StorefinderContactDialog.vue?vue&type=script&lang=js"
export * from "./StorefinderContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a16036e')) {
      api.createRecord('6a16036e', component.options)
    } else {
      api.reload('6a16036e', component.options)
    }
    module.hot.accept("./StorefinderContactDialog.vue?vue&type=template&id=6a16036e", function () {
      api.rerender('6a16036e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/storefinder/Resources/Private/Assets/Scripts/Components/StorefinderContactDialog.vue"
export default component.exports